// @owners { team: patients }
import { SPACING } from '@alto/design-library-tokens';
import { Description, InlineAlert, LgPadding } from '@alto/design-system';
import React from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';
import { PhoneNumber } from '../../../..';

const PulledUpContainer = styled(View)`
  margin-top: -${SPACING.STATIC.MD.px};
`;

export const GskSpeedUpSection = () => {
  return (
    <PulledUpContainer>
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        <InlineAlert>
          <Description fontFamily="semibold">Need this order faster?</Description>
          <Description>
            Contact us to upgrade your shipping speed: <PhoneNumber origin="gsk_for_you_speed_up_alert" />
          </Description>
        </InlineAlert>
      </LgPadding>
    </PulledUpContainer>
  );
};
